import React, {FunctionComponent} from "react";
import {InputText} from 'primereact/inputtext';
import {ICommonComponentEditorProps} from "../../ComponentType";
import {ISeparatorProps} from "./Separator";


function SeparatorEditor({ config, onConfigChange }: ICommonComponentEditorProps) {
    const conf: ISeparatorProps = config ?? {};
    const handleConfigChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
        conf.title = e.target.value;
        onConfigChange(conf);
    }

    return (
        <div className={`flex flex-column gap-2`}>
            <label htmlFor="title">Title</label>
            <InputText autoFocus id="title" type="text" value={conf.title} onChange={handleConfigChange} />
        </div>
    )
}

export default SeparatorEditor as FunctionComponent